export const getDownloadDesktopAppLink = () => {
  const location = window.location.hostname;

  // todo
  if (location.includes('localhost')) {
    return '';
  }
  if (location.includes('mac.local')) {
    return '';
  }
  if (location === 'demo.autoscript.ai') {
    return 'https://as-desktop-demo.s3.amazonaws.com/AutoscriptDesktopDemo-win-Setup.exe';
  }
  if (location === 'staging.autoscript.ai') {
    return 'https://as-desktop-staging.s3.amazonaws.com/AutoscriptDesktopStaging-win-Setup.exe';
  }
  return 'https://as-desktop.s3.amazonaws.com/AutoscriptDesktopProduction-win-Setup.exe';
};
